function isMaxWidth(maxWidth) {
  if (window.matchMedia) {
    return window.matchMedia('(max-width:' + maxWidth + 'px)').matches;
  }
}

export default isMaxWidth;



// WEBPACK FOOTER //
// ./scripts/util/isMaxWidth.js